import { englishValidationMessages } from './messages';
import { getMaxLengthValidator, getMinLengthValidator, getPatternValidator } from './rawValidators';
import { getRequiredValidator } from './required';
const minLength = 3;
const maxLength = 8;
export const defaultInvoicePrefixValueName = englishValidationMessages.fieldNames.invoicePrefix;
export const getInvoicePrefixLengthError = (valueName, min, max)=>englishValidationMessages.invoicePrefixFormat({
        field: valueName,
        min,
        max
    });
export const makeInvoicePrefixValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ const getInvoicePrefixValidator = function getInvoicePrefixValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.invoicePrefix, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, maxLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : maxLength;
        return (value)=>{
            const requiredError = getRequiredValidator(required)(value);
            if (requiredError !== true) {
                return requiredError;
            }
            const isValid = getMinLengthValidator(minLength)(value) && getMaxLengthValidator(maxLimit)(value) && getPatternValidator(/^[a-zA-Z]*$/)(value);
            return isValid || messages.invoicePrefixFormat({
                field: valueName,
                min: minLength,
                max: maxLimit
            });
        };
    };
    /** For react-hook-form library. */ const invoicePrefixValidation = function invoicePrefixValidation(valueName) {
        let { required, maxLimit } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                invoicePrefix: getInvoicePrefixValidator(valueName, required, maxLimit)
            },
            dataAttr: {
                'data-validation': 'invoice-prefix'
            }
        };
    };
    return {
        getInvoicePrefixValidator,
        invoicePrefixValidation
    };
};
export const { getInvoicePrefixValidator, invoicePrefixValidation } = makeInvoicePrefixValidators(englishValidationMessages);
